import "./index.scss";

import ReactDOM from "react-dom";
import React from "react";

import { themeChanger as setTheme } from 'mondrian-vanilla/core/util/theme-changer';

try {
  window.MondrianReact = {
    setTheme: setTheme
  }
} catch (err) {
  console.log("Warning! Window object not founded. SeTheme will not be set globally.\nHint:If you want to use setTheme, use withs imports.")
}

import Button from './baseComponents/Button';
import Divider from './baseComponents/Divider';
import Heading from './baseComponents/Heading';
import Text from './baseComponents/Text';
import Header from './baseComponents/Header';
import Footer from './baseComponents/Footer';
import Link from './baseComponents/Link';
import Input from './baseComponents/Input';
import { Container, Row , Col } from './baseComponents/Grid/';
import Accordion from './baseComponents/Accordion';
import Avatar from './baseComponents/Avatar';
import Checkbox from './baseComponents/Checkbox';
import Tag from './baseComponents/Tag';
import Toggle from './baseComponents/Toggle';
import Spinner from './baseComponents/Spinner';
import Radio from './baseComponents/Radio';
import Shortcut from './baseComponents/Shortcut';
import Collapse from './baseComponents/Collapse';
import ProgressBar from './baseComponents/ProgressBar';
import RatingStars from './baseComponents/RatingStars';
import LinkList from './baseComponents/LinkList';
import Slider from './baseComponents/Slider';
import Steps from './baseComponents/Steps';
import Image from './baseComponents/Image';
import Banner from './baseComponents/Banner';
import Topic from './baseComponents/Topic';
import TabSelect from './baseComponents/TabSelect';
import Breadcrumb from './baseComponents/Breadcrumb';
import SwiperSlide from './baseComponents/SwiperSlide';
import Card from './baseComponents/Card';
import Subtitle from './baseComponents/Subtitle';
import HelpPassword from './baseComponents/HelpPassword';
import Price from './baseComponents/Price';
import LinkDetails from './baseComponents/LinkDetails';
import Modal from './baseComponents/Modal';
import Tooltip from './baseComponents/Tooltip';

export {
  // Core
  ReactDOM,
  React,
  setTheme,
  // Components
  Button, 
  Modal,
  Divider,
  Heading,
  Text,
  Header,
  Footer,
  Link,
  Input,
  Container,
  Row,
  Col,
  Accordion,
  Avatar,
  Checkbox,
  Tag,
  Toggle,
  Spinner,
  Radio,
  Shortcut,
  Collapse,
  ProgressBar,
  RatingStars,
  LinkList,
  Slider,
  Steps,
  Image,
  Banner,
  Topic,
  TabSelect,
  Breadcrumb,
  SwiperSlide,
  Card,
  Subtitle,
  HelpPassword,
  Price,
  LinkDetails,
  Tooltip
}
